import { useState } from 'react';
import { getDontShowAgainPreference, setDontShowAgainPreference } from 'utils/dontShowAgain';
import { ModalName } from 'features/modal/types';

export type UseDontShowAgainParams = {
  modalName: ModalName | string;
  onConfirm: () => void;
};

export const useDontShowAgain = (params: UseDontShowAgainParams) => {
  const { modalName } = params;

  const [dontShowAgain, setDontShowAgain] = useState(() => getDontShowAgainPreference(modalName));

  const savePreference = () => {
    setDontShowAgainPreference(modalName, dontShowAgain);
  };

  const handleChange = (checked: boolean) => {
    setDontShowAgain(checked);
  };

  return {
    dontShowAgain,
    handleChange,
    savePreference,
  };
};
